// import DanielAminatiMTC from '../../pages/DanielAminatiMTC'
import DanielAminatiMTC from '../../pages/daniel-aminati-mtc/DanielAminatiMTC'

import PrefixEnum from '../prefixes'

export default Object.freeze([
    { path: PrefixEnum.DANIEL_AMINATI_MTC, component: DanielAminatiMTC },
])
